$ = require 'jquery'
Auth = require 'db/auth'
ApiError = require 'network/api-error'
AutoInsertionView = require 'views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'views/internal/autocomplete/auto-mentioner-view'
BoardListAnnouncementComponent = require 'views/board-list/board-list-announcement-component'
BoardListItemAddComponent = require 'views/board-list/board-list-item-add-component'
BoardListItemComponent = require 'views/board-list/board-list-item-component'
BoardListItemDndComponent = require 'views/board-list/board-list-item-dnd-component'
BoardListSectionComponent = require 'views/board-list/board-list-section-component'
BoardListSectionDndComponent = require 'views/board-list/board-list-section-dnd-component'
BoardListSectionHeaderComponent = require 'views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'views/board-list/board-list-section-header-link-component'
BoardsPageAnnouncement = require 'data/boards-page-announcement'
CompleterUtil = require 'views/internal/autocomplete/completer-util'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
CreateOrgView = require 'views/organization/create-org-view'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
EmojiCompleterView = require 'views/internal/autocomplete/emoji-completer-view'
GoldBannerView = require 'views/member/gold-banner-view'
HomeContainer = require 'views/home/home-container'
lastOrganization = require('common/lib/util/last-organization').default
ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
RecentBoards = require 'lib/recent-boards'
recentBoardsHelper = new RecentBoards()
Storage = require 'lib/storage'
TeamBannerView = require 'views/member/team-banner-view'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
createBoardHelpers = require 'views/board-create/helpers'
f = require 'effing'
getGoldBanner = require 'lib/util/get-gold-banner'
getTeamBanner = require 'lib/util/get-team-banner'
l = require 'lib/localize'
mixin = require 'lib/mixin'
ninvoke = require 'lib/util/ninvoke'
recup = require 'recup'
SidebarState = require 'view-models/sidebar-state'
{ TeamCards } = require 'views/home/presentational/team-cards'
TeamCardsDueContainer = require 'views/home/team-cards-due-container'
TeamCardsAssignedContainer = require 'views/home/team-cards-assigned-container'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'

LastOrganization = lastOrganization Storage

module.exports = mixin AutoInsertionView, CompleterUtil, class MemberHomeView extends View

  events: Util.extendEvents
    'keyup .js-text': 'keyAutoMention'
    'keydown .js-text': 'keydownJsText'

  initialize: ->
    @listenTo @model.organizationList, 'add remove reset change:memberships',
      @frameDebounce @renderBanner

    @listenTo @model.organizationList, 'add remove reset change:name change:displayName change:logoHash change:products',
      @frameDebounce @renderReactSection

    @listenTo @model.boardList,
      'add remove reset change:name change:idOrganization change:dateLastActivity change:dateLastView change:closed',
      @frameDebounce @renderReactSection

    @listenTo @model.boardStarList, 'add remove reset change:pos',
      @renderReactSection

    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderReactSection
    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderBanner

  className: 'member-boards-view'

  keydownJsText: (e) ->
    if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
      @checkInsert?(e)

  focusedCard: null

  getCard: ->
    return @focusedCard

  setFocusedCard: (idCard) =>
    @focusedCard = idCard

  getTextInput: ->
    @$('.js-text:focus')

  getEmojiTarget: ->
    @$('.js-text:focus')

  getMentionTarget: ->
    @$('.js-text:focus')[0]

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @showHomeContainer()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  renderBanner: ->
    $banners = @$('.js-boards-page-banners').empty()

    {
      bannerToDisplay
      idBannersToDismiss
    } = getTeamBanner(@model)

    goldBanner = getGoldBanner(@model)

    if bannerToDisplay
      if goldBanner && !bannerToDisplay.doesIncludeGold
        $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner, idTeamBannersToDismiss: idBannersToDismiss }).render().el)
      else
        $banners.prepend(new TeamBannerView({ bannerToDisplay, idBannersToDismiss, @model }).render().el)
        track('Boards Page', 'Team Banner Displayed', bannerToDisplay.type)
        trackUe('Boards Page', 'display', 'team banner', '', 'to a user',  '', bannerToDisplay.type)
    else if goldBanner
      $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner }).render().el)

  render: ->
    @$el.html('<div class="js-boards-page-banners"></div><div class="js-boards-page"></div>')
    @$reactRoot ?= @$('.js-boards-page')
    @orgname = @options.orgname
    @superHomeAllBoardsTab = @options.superHomeAllBoardsTab
    @superHomeCardsTabName = @options.superHomeCardsTabName

    @renderReactSection()
    @renderBanner()

    @

  showAllBoards: ->
    props =
      items: @getStarredBoards().map((board) =>
        @boardToBoardItemDndElement(board, 'Starred Boards'))
      header: @getStarredBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionDndComponent, props

    props =
      items: @getRecentBoards().map((board) =>
        @boardToBoardItemElement(board, 'Recent Boards'))
      header: @getRecentBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionDndComponent, props

    props =
      items: @getMyBoards().map((board) =>
        @boardToBoardItemElement(board, 'Personal Boards'))
      header: @getMyBoardsHeader()
      mayBeSorted: true
      noSidebarMod: true
      createNewItem: React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', @model)

    recup.createElement BoardListSectionComponent, props

    for org in @model.getSortedOrgs()
      props =
        items: @getOrgBoards(org).map((board) =>
          @boardToBoardItemElement(board, 'Team Boards'))
        header: @getOrgHeader(org)
        mayBeSorted: true
        noSidebarMod: true
        createNewItem: React.createElement BoardListItemAddComponent,
          preloadData: f(@, 'preloadCreateBoardData')
          newBoard: f(@, 'newBoard', org)
        orgId: org.id
        orgName: org.get('name')
      recup.createElement BoardListSectionComponent, props

  showTeamBoards: ->
    org = ModelCache.findOne('Organization', 'name', @orgname)

    props =
      items: @getStarredOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Starred Boards'))
      header: @getStarredBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionComponent, props

    props =
      items: @getOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Team Boards'))
      header: @getUserTeamBoardsHeader()
      noSidebarMod: true
      createNewItem: React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', org)
      orgId: org.id
      orgName: org.get('name')
    recup.createElement BoardListSectionComponent, props

    props =
      items: @getNonMemberOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Team Boards'))
      header: @getTeamBoardsHeader()
      noSidebarMod: true
      createNewItem: React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', org)
      orgId: org.id
      orgName: org.get('name')
    recup.createElement BoardListSectionComponent, props

  showTeamCards: (cardsTabName) ->
    org = ModelCache.findOne('Organization', 'name', @orgname)

    props =
      modelCache: @modelCache
      orgId: org.id
      orgName: org.get('name')

    trackDueClick = ->
      trackUe('home', 'shows', 'due dates', '', '', "by clicking due dates in top tab bar when filtered by team", { teamId: org.id })

    trackAssignedClick = ->
      trackUe('home', 'shows', 'assigned cards', '', '', "by clicking assigned in top tab bar when filtered by team", { teamId: org.id })

    recup.tag TeamCards, {
      cardsTabName, @orgname
      onClickDueTab: trackDueClick
      onClickAssignedTab: trackAssignedClick
    }, ->
      if cardsTabName == 'due'
        recup.tag TeamCardsDueContainer, props
      else if cardsTabName == 'assigned'
        recup.tag TeamCardsAssignedContainer, props

  showHomeContainer: ->
    # TODO: When we add the sidebar with Homecoming, we should get rid
    # noSidebarMod (see also
    # views/board-list/board-list-section-component.coffee and
    # boards-page-board-section.less).

    recup.render => recup.div =>
      showAnnouncement =
        BoardsPageAnnouncement?.enabled &&
        !@model.isDismissed(BoardsPageAnnouncement.id) &&
        window.locale == BoardsPageAnnouncement.locale &&
        Date.now() < Dates.parse(BoardsPageAnnouncement.dateExpires)

      if showAnnouncement
        if !@_recordedDisplayed
          @_recordedDisplayed = true
          track("Boards Page Announcement", "Displayed", BoardsPageAnnouncement.id)
        recup.createElement BoardListAnnouncementComponent, {
          icon: BoardsPageAnnouncement.icon
          message: BoardsPageAnnouncement.message
          onClick: (e) =>
            if e.target.href?
              track("Boards Page Announcement", "Click", BoardsPageAnnouncement.id, e.target.href)
          onDismiss: (message) =>
            @model.dismiss(BoardsPageAnnouncement.id)
            track("Boards Page Announcement", "Dismiss", BoardsPageAnnouncement.id)
        }

      recup.createElement HomeContainer, {
        modelCache: @modelCache
        model: @model
        orgname: @orgname
        allBoards: !@orgname && @superHomeAllBoardsTab && @showAllBoards.bind(@)
        orgBoards: @orgname && @superHomeAllBoardsTab && @showTeamBoards.bind(@)
        orgCards: @superHomeCardsTabName && @showTeamCards.bind(@, @superHomeCardsTabName)
        setFocusedCard: @setFocusedCard
      }

  backgroundObjForBoard: (board) ->
    _.extend brightness: board.getPref('backgroundBrightness'),
      if board.getPref('backgroundTile')
        image: board.getPref('backgroundImage')
        tiled: true
      else if preview = Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? board.getPref('backgroundImage')
        image: preview
        tiled: false
      else
        color: board.getPref('backgroundColor') ? board.getClientBackgroundColor('blue')

  boardToBoardItemDndElement: (board, sectionName) ->
    props = @boardToBoardItemProps(board, sectionName)
    props.onDragHover = (idBoardHoverer) =>
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(idBoardHoverer)
      index = boardStarList.getBoardIndex(board.id)
      pos = boardStarList.getNewPos(boardStar, index)
      boardStar.set({ pos })
    props.onDragEnd = ->
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(board.id)
      Promise.using ModelCache.getLock(), ->
        ninvoke boardStar, 'update', (pos: boardStar.get('pos'))
        .catch ->
      .done()
      return
    props.orgname = board.getOrganization()?.get('displayName')
    props.isDraggable = true

    React.createElement BoardListItemDndComponent, props

  boardToBoardItemElement: (board, sectionName) ->
    React.createElement BoardListItemComponent,
      @boardToBoardItemProps(board, sectionName)

  boardToBoardItemProps: (board, sectionName) ->
    id: board.id
    name: board.get('name')
    hasUnseenActivity: board.hasUnseenActivity()
    dateLastActivity: new Date(board.get('dateLastActivity') ? Util.idToDate(board.id))
    isLessActive: board.isLessActive()
    background: @backgroundObjForBoard(board)
    showOptions: Auth.isLoggedIn()
    isStarred: Auth.me().boardStarList.getBoardStar(board.id)?
    relUrl: board.getUrl()
    onStarClick: (idBoard) =>
      boardStarList = Auth.me().boardStarList
      Promise.using ModelCache.getLock(), ->
        if !boardStarList.getBoardStar(idBoard)?
          boardStarList.starBoard(idBoard)
          track('Boards View', 'Star Board', sectionName)
        else
          boardStarList.unstarBoard(idBoard)
          track('Boards View', 'Unstar Board', sectionName)
      .done()
      return
    badgeComponents: []
    tagComponents: []
    key: board.id
    onBoardClick: ->
      track('Boards View', 'Click on Board', sectionName)

  preloadCreateBoardData: ->
    createBoardHelpers.preloadData()

  newBoard: (model, el) ->
    if maybeDisplayMemberLimitsError($(el), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: if model.typeName == 'Organization' then model else LastOrganization.NO_ORGANIZATION
        trackingOpts: { category: 'home', method: 'by clicking create new board button in boards tab' }

    track("Boards View", "Clicked 'Create new board' Button")
    return

  getMyBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.personal boards')
      iconClass: 'member'
    }

  getMyBoards: ->
    _.filter @model.boardList.models, (board) -> !board.isOrgBoard() && board.isOpen()

  getOrgHeader: (org) ->

    props =
      title: org.get('displayName')
      iconClass: 'organization'
      logoHash: org.get('logoHash')
      linkElements: [
        {
          url: Controller.getOrganizationUrl(org),
          iconClass: 'board',
          titleKey: 'boards',
          onClick: ->
            track 'Boards View', 'Clicked Team Boards Button'
        },
        {
          url: Controller.getOrganizationMembersUrl(org),
          iconClass: 'member',
          titleKey: 'members',
          onClick: ->
            track 'Boards View', 'Clicked Team Members Button'
        },
        {
          url: Controller.getOrganizationAccountUrl(org),
          iconClass: 'gear',
          titleKey: 'settings',
          onClick: ->
            track 'Boards View', 'Clicked Team Settings Button'
        }
      ].map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))

    if org.isFeatureEnabled('enterpriseUI')
      props.smallIconClass = 'enterprise'
      props.smallIconTitleKey = 'enterprise'
    else if org.isPremium()
      props.smallIconClass = 'business-class'
      props.smallIconTitleKey = 'business-class'

    React.createElement BoardListSectionHeaderComponent, props

  getOrgBoards: (org) ->
    _.filter @model.boardList.models, (board) =>
      board.getOrganization()?.id == org.id &&
      board.isOpen()

  getNonMemberOrgBoards: (org) ->
    # gets all org boards that current user isn't a part of
    userOrgBoardIds = @getOrgBoards(org).map((board) => board.get('id'))

    _.chain org.boardList.models
    .filter (board) => board.isOpen()
    .map (board) => board.get('id')
    .difference userOrgBoardIds
    .map (boardId) => ModelCache.get('Board', boardId)
    .value()

  getStarredBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.starred boards')
      iconClass: 'star'
    }

  getStarredBoards: ->
    _.filter @model.boardStarList.getBoards(), (board) ->
      board.isOpen()

  getStarredOrgBoards: (org) ->
    _.filter @model.boardStarList.getBoards(), (board) ->
      board.getOrganization()?.id == org.id &&
      board.isOpen()

  getRecentBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('home board section title.recent')
      iconClass: 'clock'
    }

  getRecentBoards: ->
    recentBoardsHelper.getBoards(@model, @renderReactSection.bind(@)).slice(0, 4)

  getUserTeamBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.your team boards')
      iconClass: 'member'
    }

  getTeamBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.team boards')
      iconClass: 'organization'
    }

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-home-view.coffee